import { useEmailAttachmentWithFile } from "models/actions/apiAction";
import DownloadIcon from "@mui/icons-material/Download";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";

const AttachmentDownloadButton = ({ attachment: originalAttachment }) => {
  const [attachmentId, setAttachmentId] = useState(null);
  const { data } = useEmailAttachmentWithFile(attachmentId);

  const handleDownload = () => {
    if (originalAttachment.status === "completed") {
      return;
    }
    setAttachmentId(originalAttachment.id);
  };

  const attachment = data || originalAttachment;

  return (
    <>
      {attachment.file && (
        <IconButton href={attachment.file} target="_blank">
          <DownloadIcon />
        </IconButton>
      )}
      {attachment.file && attachmentId && (
        <a
          href={attachment.file}
          rel="noopener noreferrer"
          download={attachment.attachment_name}
          style={{ display: "none" }}
          ref={(link) =>
            link && link.click() && link.remove() && setAttachmentId(null)
          }
        />
      )}
      {!attachment.file && (
        <IconButton onClick={handleDownload}>
          <DownloadIcon />
        </IconButton>
      )}
    </>
  );
};

export default AttachmentDownloadButton;
